
// Vanilla JS DOM Ready
document.addEventListener('DOMContentLoaded', function() {

    var elTestionialCarousel = document.querySelector('.js-testimonial-carousel');

    if(elTestionialCarousel){
        var elTestionialSlides = elTestionialCarousel.querySelectorAll('.glide__slide'); // NodeList
        if(elTestionialSlides.length > 1){
            
            new Glide(elTestionialCarousel, {
                type: 'carousel',
                autoplay: 5000,
                hoverpause: true
            }).mount();
            
        }
    }

    // Site navigation
    var elNav = document.querySelector('.js-mobile-nav');
    if(elNav) {

        var mmDesktop = window.matchMedia('(max-width: 58em)');

        if (mmDesktop.matches) {
            setNavMobile.init(elNav);
        }

        mmDesktop.onchange = function (event) {
            if(mmDesktop.matches){
                setNavMobile.init(elNav);
            }else{
                setNavMobile.destroy(elNav);
            }
        };

    }

    // Summary dropdown
    var elSummaryDropdown = document.querySelector('.js-summary-dropdown-link');
    if(elSummaryDropdown){
        setSummaryDropdown.init();
    }

    // col conform
    var elColConform = document.querySelector('.js-col-conform');
    if(elColConform){
        var colConform = new ColConform;
        // Initialise col conform
        colConform.init({
            el: '.js-col-conform',
            innerItems: ['.summary-content']
        });
    }

    // accordion
    var elAccordion = document.querySelector('.js-accordion');


    if(elAccordion){
        const elContentAll = elAccordion.querySelectorAll('.accordion-panel');
        const elBtnAll = elAccordion.querySelectorAll('.accordion-btn');
        elAccordion.addEventListener('click', (e)=>{
            const elBtn = e.target.closest('.accordion-btn');
            if(!elBtn) return;
            e.preventDefault();
            const elContent = elBtn.nextElementSibling
            elContentAll.forEach((el, idx)=>{
                const elCurrentBtn = elBtnAll[idx];
                if(el===elContent){
                    const expanded = elCurrentBtn.ariaExpanded === 'true';
                    if(expanded){
                        elCurrentBtn.setAttribute('aria-expanded', 'false');
                        el.classList.add('accordion-hidden');
                    }else{
                        elCurrentBtn.setAttribute('aria-expanded', 'true');
                        el.classList.remove('accordion-hidden');
                    }
                }else{
                    // close all
                    elCurrentBtn.ariaExpanded = false;
                    el.classList.add('accordion-hidden');
                }
                
            })
        })
    }


});
